<template>
  <div>
    <v-sheet
      tabindex="0"
      width="100%"
      class="pa-2"
      ref="dropzone"
      :class="{ 'dashed-border': currentDirectory.name !== '/', 'dragover-active': dragover }"
    >
      <div
        class="text-left pt-12"
        v-if="currentDirectory.name !== '/' && currentDirectory.files.length == 0"
      >
        Aucune pièce jointe n'a été ajoutée.
      </div>
      <v-row>
        <v-col cols="4" v-for="(file, index) in currentDirectory.files" v-bind:key="index">
          <p>
            <a
              :class="{ 'mr-1': index < currentDirectory.files.length - 1 }"
              :href="urlPrefix + file.chemin"
              target="_blank"
            >
              <img v-if="file.name.split('.').pop() == 'pdf'" src="@/assets/pdf.png" alt="" />
              <img
                v-else-if="
                  file.name.split('.').pop().substring(0, 3) == 'doc' ||
                  file.name.split('.').pop().substring(0, 3) == 'txt'
                "
                src="@/assets/doc.png"
                alt=""
              />
              <img
                v-else-if="
                  file.name.split('.').pop().substring(0, 3) == 'xls' ||
                  file.name.split('.').pop().substring(0, 3) == 'csv'
                "
                src="@/assets/excel.png"
                alt=""
              />
              <img v-else src="@/assets/img.png" alt="" />
            </a>
          </p>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <p v-bind="attrs" v-on="on">{{ displayName(file.name) }}</p>
            </template>
            <span>{{ displayName(file.name) }}</span>
          </v-tooltip>
          <p>ajouté le : {{ $moment(file.lastModified).format('DD/MM/YYYY') }}</p>
          <p>
            <v-btn v-if="mode !== 'visualisation'" @click="deleteDocument(file, index, true)">
              <strong>Supprimer</strong>
            </v-btn>
          </p>
        </v-col>
      </v-row>
    </v-sheet>

    <Popup
      :dialog="dialog"
      text="Supprimer ce document ?"
      actions=""
      heightProp=""
      widthProp=""
      @emitDialog="dialog = $event"
      showClose="false"
    >
      <v-card-actions class="mb-10">
        <v-btn class="actions mr-10" color="#0B87BA" width="100px" large dark rounded @click="dialog = false">Non</v-btn>
        <v-btn class="actions" color="#0B87BA" width="100px" large dark rounded @click="confirmDelete">Oui</v-btn>
      </v-card-actions>
    </Popup>
  </div>
</template>

<script>
import api_doc from "@/api/document";
import Popup from "@/components/shared/Popup";

export default {
  props: {
    mode: [String],
    currentDirectory: {
      type: Object,
    },
  },
  components: { Popup },

  data() {
    return {
      urlPrefix: process.env.VUE_APP_BASE_URL,
      documentToDelete: null,
      indexToDelete: null,
      dialog: false,
      dragover: false,
    };
  },

  computed: {
    projectId() {
      return this.$route.params.id_projet;
    },
  },

  methods: {
    displayName(name) {
      const stripped = name.substring(name.indexOf('-') + 1);
      return stripped.length > 30 ? stripped.substring(0, 30) + '…' : stripped;
    },

    deleteDocument(document, index, open) {
      if (open) {
        this.documentToDelete = document;
        this.indexToDelete = index;
        this.dialog = true;
      }
    },

    confirmDelete() {
      const document = this.documentToDelete;
      const index = this.indexToDelete;
      if (document.chemin !== undefined && document.saved) {
        api_doc
          .deleteProjectDocument(this.$route.params.id_entreprise, this.projectId, document)
          .then(() => {
            this.currentDirectory.files.splice(index, 1);
          })
          .catch(() => {
            this.$store.dispatch('notify', { message: 'Erreur lors de la suppression' });
          });
      } else {
        this.currentDirectory.files.splice(index, 1);
      }
      this.dialog = false;
    },
  },

  mounted() {
    const dropzone = this.$refs.dropzone.$el;
    if (dropzone) {
      dropzone.addEventListener("dragenter", e => {
        e.preventDefault();
        this.dragover = true;
      });
      dropzone.addEventListener("dragleave", e => {
        e.preventDefault();
        this.dragover = false;
      });
      dropzone.addEventListener("dragover", e => {
        e.preventDefault();
        this.dragover = true;
      });
      dropzone.addEventListener("drop", e => {
        e.preventDefault();
        this.dragover = false;
        if (e.dataTransfer) {
          for (const file of e.dataTransfer.files) {
            this.$emit('emitFile', file);
          }
        }
      });
    }
  },
};
</script>

<style scoped>
.dashed-border {
  border: 2px dashed #ccc;
  min-height: 150px;
  transition: border-color 0.2s, background-color 0.2s;
}

.dashed-border.dragover-active {
  border-color: #0b87ba;
  background-color: #e3f2fd;
}

img {
  width: 29px;
  height: 28px;
}

.font_color {
  font-weight: bold;
  color: #ffffff;
}

::v-deep .v-breadcrumbs__item {
  align-items: center;
  display: inline-flex;
  text-decoration: none;
  transition: .3s cubic-bezier(.25,.8,.5,1);
  color: blue;
}

.active {
  cursor: pointer;
  font-weight: bold;
}

::v-deep .v-breadcrumbs__divider {
  font-weight: bold;
  color: blue !important;
}

.disable {
  font-weight: normal !important;
}

.v-breadcrumbs li .v-icon {
  font-size: 16px;
  color: blue;
}
</style>
